import { THEMES } from "../../data/content";

const ORDER = ["telephonie", "infogerance", "conseil-audit", "vente-import", "ia-automatisation"];

export const ColorBand = ({ height = 6, className = "" }) => (
  <div className={`flex w-full ${className}`} style={{ height }} data-testid="color-band">
    {ORDER.map((s) => (
      <span key={s} className="flex-1" style={{ background: THEMES.find((t) => t.slug === s).color }} />
    ))}
  </div>
);
